import request from '@/utils/request'

export function fetchRole (params){
    return request({
        url: '/auth/roles',
        method: 'get',
        params: params,
    })
}

export function createRole (data) {
  return request({
    url: '/auth/roles/create',
    method: 'post',
    data: data
  })
}

export function updateRole (id, data) {
  return request({
    url: `/auth/roles/update/${id}`,
    method: 'put',
    data: data
  })
}

export function deleteRole (id) {
  return request({
    url: `/auth/roles/delete/${id}`,
    method: 'delete',
  })
}


export function restoreRole (id) {
  return request({
    url: `/auth/roles/restore/${id}`,
    method: 'delete',
  })
}
